import React, { useState, useEffect } from "react";
import { Tabs, message } from "antd";
import axios from "axios";
import {
  getAssignPermissionsToUserRoute,
  getAssignRolesToUserRoute,
  getBlockPermissionsToUserRoute,
  getUserByIdRoute,
} from "../../lib/rolesRoutes";
import AdministrationRoles from "../../components/AdministrationRoles/AdministrationRoles";
import AdministrationPermissions from "../../components/AdministrationPermissions/AdministrationPermissions";
import AdministrationBlockPermissions from "../../components/AdministrationBlockPermissions/AdministrationBlockPermissions";
import { hasAccess } from "../../hasAccess";
import {
  MENU_USER_USERMANAGEMENT_WRITE,
  USERMANAGEMENT_USER_PERMISSIONS,
  USERMANAGEMENT_USER_ROLES,
} from "../../../../lib/const/permissions";

const { TabPane } = Tabs;

function AdministrationContainer(props) {
  const {
    selectedAdministrationTab,
    handleChangeAdministrationTab,
    roles,
    permissions,
    getUsers,
    permissionsLoading,
  } = props;

  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState();

  const handleSelectUser = async (userId) => {
    const response = axios.get(getUserByIdRoute(userId));
    const { data } = await response;
    setSelectedUser(data);
  };

  const fetchUser = () => {
    handleSelectUser(selectedUser.id).catch(() => {
      message.error("Ошибка");
    });
  };

  const fetchUsers = () => {
    getUsers(0, 1000).then((res) => {
      setUsers(res.content);
    });
  };

  useEffect(() => {
    fetchUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleAssignRolesToUser = async (rolesArr) => {
    try {
      const response = axios.put(getAssignRolesToUserRoute(selectedUser.id, rolesArr));
      const { status } = await response;
      message.success("Роли отредактированы");
      fetchUser();
      return true;
    } catch (e) {
      message.error("Ошибка");
      return false;
    }
  };

  const handleAssignPermissionsToUser = async (permissionsArr) => {
    try {
      await axios.put(
        getAssignPermissionsToUserRoute(
          selectedUser.id,
          permissionsArr,
          selectedUser.excludedPermissions.map((item) => item.id)
        )
      );
      message.success("Привилегии отредактированы");
      fetchUser();
      return true;
    } catch (e) {
      message.error("Ошибка");
      return false;
    }
  };

  const handleBlockPermissionsToUser = async (permissionsArr) => {
    try {
      await axios.put(
        getBlockPermissionsToUserRoute(
          selectedUser.id,
          permissionsArr,
          selectedUser.includedPermissions.map((item) => item.id)
        )
      );
      message.success("Привилегии отредактированы");
      fetchUser();
      return true;
    } catch (e) {
      message.error("Ошибка");
      return false;
    }
  };

  const renderAdministrationTabs = () => (
    <Tabs
      onChange={handleChangeAdministrationTab}
      defaultActiveKey={selectedAdministrationTab}
      type="card"
    >
      {hasAccess(MENU_USER_USERMANAGEMENT_WRITE, USERMANAGEMENT_USER_ROLES) && (
        <TabPane tab="Назначение/отмена ролей" key="1">
          <AdministrationRoles
            selectedUser={selectedUser}
            handleSelectUser={handleSelectUser}
            handleAssignRolesToUser={handleAssignRolesToUser}
            users={users}
            roles={roles}
          />
        </TabPane>
      )}
      {hasAccess(MENU_USER_USERMANAGEMENT_WRITE, USERMANAGEMENT_USER_PERMISSIONS) && (
        <TabPane tab="Назначение/отмена привилегий" key="2">
          <AdministrationPermissions
            user={selectedUser}
            selectedUser={selectedUser}
            handleSelectUser={handleSelectUser}
            handleAssignPermissionsToUser={handleAssignPermissionsToUser}
            users={users}
            permissions={permissions}
            permissionsLoading={permissionsLoading}
          />
        </TabPane>
      )}
      {hasAccess(MENU_USER_USERMANAGEMENT_WRITE, USERMANAGEMENT_USER_PERMISSIONS) && (
        <TabPane tab="Блокировка привилегий" key="3">
          <AdministrationBlockPermissions
            user={selectedUser}
            selectedUser={selectedUser}
            handleSelectUser={handleSelectUser}
            handleBlockPermissionsToUser={handleBlockPermissionsToUser}
            users={users}
            roles={roles}
            permissions={permissions}
            permissionsLoading={permissionsLoading}
          />
        </TabPane>
      )}
    </Tabs>
  );

  return renderAdministrationTabs();
}

export default AdministrationContainer;
